import type { DenormalizedBlockEntity } from '@web/types';

import { createActionGroup, props } from '@ngrx/store';

const PageStructureActions = createActionGroup({
    source: 'Page Structure',
    events: {
        'Set page structure': props<{ structure: DenormalizedBlockEntity[] }>(),
    },
});

export default PageStructureActions;
